<template>
  <div class="data-card">
    <div v-for="item in bookData"
         :key="item.id"
         class="card-item"
         ref="cardItem">
      <div class="card-item__title">
        <img :src="item.image"
             alt="icon"
             class="title-image">
        <p class="title-content">{{ item.title }}</p>
        <p class="card-item__content">{{ item.data }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataCard',
  props: {},
  data () {
    return {
      bookData: [
        {
          id: 1,
          title: '古籍种数',
          image: require('@/assets/images/book.png'),
          data: '0'
        },
        {
          id: 2,
          title: '图片张数',
          image: require('@/assets/images/image.png'),
          data: '0'
        },
        {
          id: 3,
          title: '标引条数',
          image: require('@/assets/images/indexing.png'),
          data: '0'
        },
        {
          id: 4,
          title: '全文字数',
          image: require('@/assets/images/font.png'),
          data: '0'
        }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      let url = 'retrieve/home/getHomeData'
      this.$http.get(url).then(res => {
        for (let i = 0; i < this.bookData.length; i++) {
          if (this.bookData[i].title === '标引条数') {
            this.bookData[i].data = res.data.data.biaoyintiaoshu
          } else if (this.bookData[i].title === '古籍种数') {
            this.bookData[i].data = res.data.data.gujiCategory
          } else if (this.bookData[i].title === '图片张数') {
            this.bookData[i].data = res.data.data.allImage
          } else if (this.bookData[i].title === '全文字数') {
            this.bookData[i].data = res.data.data.quanwenzishu
          }
        }
        // 根据数据的大小来设置万的单位
        for (let i = 0; i < this.bookData.length; i++) {
          if (this.bookData[i].data > 10000) {
            this.bookData[i].data = (this.bookData[i].data / 10000).toFixed(0) + '万'
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.data-card {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 459px;
  height: 142px;
  background-color: #f7f2ee;
  justify-content: space-around;
}

.card-item {
  display: flex;
  flex: 1 1 auto;
  width: 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border-right: 2px solid #fff;
}

.card-item:last-child {
  border-right: none;
}

.title-image {
  width: 40px;
  height: 35px;
}

.title-content {
  font-size: 14px;
  color: #634c37;
  margin-top: 10px;
}

.card-item__content {
  margin-top: 10px;
  margin-bottom: 0;
  font-size: 26px;
  font-weight: bold;
  color: #9e5c1d;
}
</style>



// WEBPACK FOOTER //
// src/components/DataCard.vue